/**
 * Integrator admin barrel aggregator
 * Combines all integration-related handlers
 */

import type { UseAdminAppReturn } from "./useAdminApp";
import { useIntegrationsAdmin, type IntegrationsAdminHandler } from "./integrator/useIntegrationsAdmin";
import { useConnectionsAdmin, type ConnectionsAdminHandler } from "./integrator/useConnectionsAdmin";
import { useGitHubAdmin, type GitHubAdminHandler } from "./integrator/useGitHubAdmin";

export interface IntegratorAdminHandler {
  integrations: IntegrationsAdminHandler;
  connections: ConnectionsAdminHandler;
  github: GitHubAdminHandler;
}

export function useIntegratorAdmin(adminApp: UseAdminAppReturn): IntegratorAdminHandler {
  const integrations = useIntegrationsAdmin(adminApp);
  const connections = useConnectionsAdmin(adminApp);
  const github = useGitHubAdmin(adminApp);

  return {
    integrations,
    connections,
    github,
  };
}

// Re-export types for convenience
export type { IntegrationsAdminHandler, ConnectionsAdminHandler, GitHubAdminHandler };
export type { Integration } from "./integrator/useIntegrationsAdmin";
export type { Connection, ConnectionCredentials } from "./integrator/useConnectionsAdmin";

